import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SideMenuI } from '../../shared/interfaces/side-menu.interface';
import { SUPPORTS_SIDE_MENU_ITEMS } from '../constants/supports-side-menu-items';

@Component({
  selector: 'app-settings-side-menu',
  imports: [RouterLink, RouterLinkActive, TranslateModule],
  templateUrl: './settings-side-menu.html',
  styleUrl: './settings-side-menu.scss',
})
export class SettingsSideMenu {
  private readonly router = inject(Router);
  constructor() {}

  supportsSideMenuItems = SUPPORTS_SIDE_MENU_ITEMS;
  currentUrl: string = this.router.url.slice(1);
  itemOnHover: string | null = null;

  ngOnInit(): void {}

  itemBeingHovered(item: string | null) {
    this.itemOnHover = item;
  }
  sideMenuItemIcon(state: boolean, item: SideMenuI) {
    return state
      ? item.activeIcon
      : this.itemOnHover === item.route
      ? item.activeIcon
      : item.inactiveIcon;
  }
}
